// Static data for WOW AUTOBODY - No API needed
export const servicesData = [
  {
    id: "service-1",
    title: "Collision Repair",
    description: "Complete collision damage repair using state-of-the-art equipment and techniques.",
    icon: "shield-check",
    features: ["Frame straightening", "Panel replacement", "Paint matching", "Quality guarantee"],
    active: true,
    created_at: new Date().toISOString()
  },
  {
    id: "service-2", 
    title: "Dent & Scratch Removal",
    description: "Professional dent removal and scratch repair to restore your vehicle's appearance.",
    icon: "sparkles",
    features: ["Paintless dent repair", "Scratch buffing", "Minor body work", "Color matching"],
    active: true,
    created_at: new Date().toISOString()
  },
  {
    id: "service-3",
    title: "Auto Painting", 
    description: "Expert automotive painting services with premium quality finishes.",
    icon: "palette",
    features: ["Complete paint jobs", "Touch-up painting", "Custom colors", "Clear coat protection"],
    active: true,
    created_at: new Date().toISOString()
  },
  {
    id: "service-4",
    title: "Insurance Claims",
    description: "We work directly with insurance companies to streamline your repair process.", 
    icon: "file-text",
    features: ["Insurance coordination", "Claim assistance", "Direct billing", "Estimate preparation"],
    active: true,
    created_at: new Date().toISOString()
  }
];

export const galleryData = [
  {
    id: "gallery-1",
    title: "SUV Side Panel Damage", 
    description: "Side panel dent removal and paint restoration to factory specifications.",
    before_image: "/assets/imgs/beforeafter/0129-1.jpeg",
    after_image: "/assets/imgs/beforeafter/0129-2.jpeg",
    category: "collision",
    featured: true,
    created_at: new Date().toISOString()
  },
  {
    id: "gallery-2",
    title: "Sedan Front End Collision",
    description: "Complete front-end restoration including bumper, hood, and headlight replacement.",
    before_image: "/assets/imgs/beforeafter/IMG_4427.JPG",
    after_image: "/assets/imgs/beforeafter/IMG_4428.JPG",
    category: "dent",
    featured: false,
    created_at: new Date().toISOString()
  },
  {
    id: "gallery-3",
    title: "Sports Car Scratch Repair",
    description: "Precision paint work on luxury sports car with custom color matching.",
    before_image: "/assets/imgs/beforeafter/IMG_4432.JPG", 
    after_image: "/assets/imgs/beforeafter/IMG_4431.JPG",
    category: "paint", 
    featured: true,
    created_at: new Date().toISOString()
  },
  {
    id: "gallery-4",
    title: "Sedan Side Panel Damage", 
    description: "Side panel dent removal and paint restoration to factory specifications.",
    before_image: "/assets/imgs/beforeafter/TalkMedia_i_2828bc2c1aea.jpg",
    after_image: "/assets/imgs/beforeafter/TalkMedia_i_0041870eb847.jpg", 
    category: "restoration",
    featured: false,
    created_at: new Date().toISOString()
  },
  {
    id: "gallery-5",
    title: "SUV Rear Panel Damage", 
    description: "Rear panel dent removal and paint restoration to factory specifications.",
    before_image: "/assets/imgs/beforeafter/IMG_4436.JPG",
    after_image: "/assets/imgs/beforeafter/IMG_4437.JPG",
    category: "collision",
    featured: false,
    created_at: new Date().toISOString()
  },
  {
    id: "gallery-6", 
    title: "Hail Damage Repair",
    description: "Comprehensive hail damage repair using paintless dent removal techniques.",
    before_image: "/assets/imgs/beforeafter/TalkMedia_i_68908c84bfe7.jpg",
    after_image: "/assets/imgs/beforeafter/TalkMedia_i_340b4447b1fb.jpg",
    category: "dent",
    featured: true,
    created_at: new Date().toISOString()
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    text: "Outstanding service! My car looks better than it did before the accident. The team was professional and kept me updated throughout the process.",
    rating: 5
  },
  {
    id: 2,
    name: "Mike Rodriguez", 
    text: "Fast, reliable, and high-quality work. They worked directly with my insurance company which made everything so much easier.",
    rating: 5
  },
  {
    id: 3,
    name: "Jennifer Chen",
    text: "I was amazed at how well they matched the paint color. You can't even tell where the repair was done. Highly recommend!",
    rating: 5
  }
];

export const aboutInfo = {
  story: "Founded in 2010, WOW AUTOBODY has been serving the community with exceptional auto body repair services. Our commitment to quality craftsmanship and customer satisfaction has made us the trusted choice for thousands of satisfied customers.",
  mission: "To provide the highest quality auto body repair services while maintaining exceptional customer service and fair pricing. We treat every vehicle as if it were our own.",
  stats: [
    { label: "Years in Business", value: "14+" },
    { label: "Vehicles Repaired", value: "15,000+" },
    { label: "Customer Satisfaction", value: "98%" },
    { label: "Insurance Partners", value: "25+" }
  ]
};